export const Terms = {
  privacy: import.meta.env.VITE_PRIVACY_POLICY_URL,
  terms:import.meta.env.VITE_TERMS_AND_CONDITIONS_URL,
  refund: import.meta.env.VITE_CANCELLATION_AND_REFUND_POLICY_URL,
};
